export default __webpack_public_path__ + "static/photo-stack-e75bbd2489b623d51431b5669b4ca14f.jpg";